import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function postSubject(data) {
  const url = `${API_BASE_URL}/subjects`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function putSubject({ name, description, id }) {
  const url = `${API_BASE_URL}/subjects/${id}`;
  return request({
    url,
    method: "put",
    data: { name, description },
  });
}

export async function deleteSubject({ id }) {
  const url = `${API_BASE_URL}/subjects/${id}`;
  return request({
    url,
    method: "delete",
    data: {},
  });
}

export async function fetchAll(data) {
  const url = `${API_BASE_URL}/subjects`;
  return request({
    url,
    method: "get",
    data,
  });
}
